import React, { useEffect, useState } from 'react';
import { Drawer, Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { COLORS } from '../../../constants/colors';
import { StyledSelectWithHeight, MobileFilterDrawer } from '../styled';

const { Option } = StyledSelectWithHeight;

const FilterDrawer = ({
  visible,
  onClose,
  filters,
  onFiltersChange,
  selectedEvent,
  onEventChange,
  availableEvents,
  loadingEvents
}) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const handleApply = () => {
    onClose();
  };

  const handleClear = () => {
    onFiltersChange({ search: '', status: 'all', dob: null });
    onEventChange('all');
  };

  return (
    <Drawer
      title="Filter Patients"
      placement={isMobile ? 'bottom' : 'right'}
      onClose={onClose}
      open={visible}
      width={isMobile ? undefined : 300}
      height={isMobile ? 'auto' : undefined}
      styles={{
        body: { padding: '16px' },
        content: isMobile
          ? { borderTopLeftRadius: 16, borderTopRightRadius: 16 }
          : undefined
      }}
    >
      <MobileFilterDrawer>
        <div className="filter-group">
          <label className="filter-label">Event</label>
          <StyledSelectWithHeight
            placeholder="Select event"
            value={selectedEvent}
            onChange={onEventChange}
            loading={loadingEvents}
            style={{ width: '100%' }}
          >
            <Option value="all">All Events</Option>
            {availableEvents.map(event => (
              <Option key={event._id} value={event._id} title={`${event.title}${event.location ? ` - ${event.location}` : ''}`}>
                {event.title}{event.city ? ` - ${event.city}${event.state ? `, ${event.state}` : ''}` : ''}
              </Option>
            ))}
          </StyledSelectWithHeight>
        </div>
        
        <div className="filter-group">
          <label className="filter-label">Status</label>
          <StyledSelectWithHeight
            placeholder="Select status"
            value={filters.status}
            onChange={(value) => onFiltersChange({ ...filters, status: value })}
            style={{ width: '100%' }}
          >
            <Option value="all">All Statuses</Option>
            <Option value="pending_review">Pending</Option>
            <Option value="matched">Matched</Option>
            <Option value="new_patient">New</Option>
            <Option value="duplicate">Duplicate</Option>
            <Option value="needs_attention">Attention</Option>
            <Option value="archived">Archived</Option>
          </StyledSelectWithHeight>
        </div>

        <div className="filter-group">
          <label className="filter-label">Date of Birth</label>
          <DatePicker
            value={filters.dob || null}
            onChange={(value) => onFiltersChange({ ...filters, dob: value })}
            placeholder="Select birthday"
            format="MM/DD/YYYY"
            defaultPickerValue={dayjs('1985-01-01')}
            allowClear
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="clear-filters-section" style={{ display: 'flex', gap: '8px' }}>
          <Button
            onClick={handleClear}
            style={{ flex: 1 }}
          >
            Clear
          </Button>
          
          <Button
            type="primary"
            onClick={handleApply}
            style={{
              flex: 1,
              background: COLORS.$primaryBlue,
              borderColor: COLORS.$primaryBlue
            }}
          >
            Apply
          </Button>
        </div>
      </MobileFilterDrawer>
    </Drawer>
  );
};

export default FilterDrawer;
